import { notify } from "../../../../../utils/notify";
import { search } from "../../../../BaseRepositoryComponents";

const searchParams = new URLSearchParams(window.location.search);
const path = `${process.env.REACT_APP_URL_API_ERP_V3}/multitenant/conta/receber`;

const headers = new Headers();
const token = `Bearer ${searchParams.get("gfAccessToken") || ""}`;
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function getCrBankBillet({ account_ids = [] }) {
  if (!token)
    return notify(
      "Não foi possível conectar aos nossos servidores, tente novamente mais tarde."
    );

  const url = new URL(`${path}/bank-billet`);

  if (Array.isArray(account_ids)) {
    account_ids.map((id) => url.searchParams.append(`account_ids[]`, id));
  }

  return search(decodeURIComponent(url), "GET", headers);
}
